import api from "@/api/axios";

const API_URL = "/system-settings";

/**
 * keys: optional array of keys, e.g. ["llm_prompt_template", "async_rating_mode"]
 * If omitted/empty, returns all settings.
 */
export const getSystemSettings = (keys = null) => {
    const params = {};
    if (Array.isArray(keys) && keys.length > 0) {
        // FastAPI Query(List[str]) -> ?keys=a&keys=b
        params.keys = keys;
    }
    return api.get(API_URL, { params });
};

/**
 * payload example:
 * {
 *   llm_prompt_template: "...",
 *   rag_prompt_template: "...",
 *   async_rating_mode: "LLM"
 * }
 */
export const updateSystemSettings = (payload) => api.put(API_URL, payload);

/**
 * Die geltende Vorlage des Relevanz-Prompts: { vorlage, ist_vorgabe }.
 *
 * Der Relevanz-Prompt ist der einzige Block des Dialogs, der auch ohne Zeile
 * in system_settings einen wirksamen Text hat -- eine Konstante im
 * Bewertungs-Backend. Ohne diese Auskunft stuende das Feld dort leer, und ein
 * leeres Feld liest sich als "kein Prompt".
 *
 * ⚠️ Die Entscheidung, OB die Vorgabe gilt, wird bewusst nicht hier gefällt:
 * drüben zählt eine leere oder nur aus Leerzeichen bestehende Zeile als nicht
 * gesetzt. Diese Regel ein zweites Mal zu schreiben hieße, sie eines Tages
 * anders zu schreiben.
 */
export const getContextRelevanceDefault = () =>
    api.get(`${API_URL}/context-relevance-default`);
